import { SharedMarketPlaceFraudDetection } from "@app/shared";
import React from "react";

const MarketPlaceFraudDetectionList: React.FC = () => {
  return <SharedMarketPlaceFraudDetection />;
};

export default MarketPlaceFraudDetectionList;
